import type { ReadChangelogType } from '@readme/api/src/mappings/changelog/types';
import type { CustomPageReadType } from '@readme/api/src/mappings/custompage/types';
import type { ReadGuideType } from '@readme/api/src/mappings/page/guide/types';
import type { ReadReferenceType } from '@readme/api/src/mappings/page/reference/types';

import { renderMdxPlain } from '@readme/iso';

import type { VariablesContextValue } from '@core/context';

/**
 * Fetches the description value for the `<meta name=description>`
 * with the following priority:
 * - page.metadata.description (from the modal)
 * - page.content.excerpt
 * - extracted description from page.content.body
 *
 * @note This logic mirrors the `getDescription` function in our Hub express app.
 * If any changes are made to this function you must also make updates there.
 * @link /packages/hub/lib/createMetadata.ts
 */
export default function getMetaDescription(
  page: (CustomPageReadType | ReadChangelogType | ReadGuideType | ReadReferenceType)['data'] | null,
  variables: VariablesContextValue,
) {
  if (page?.metadata.description) {
    return page?.metadata.description;
  }

  const mdxOpts = { truncationLength: 300 };

  if (page && 'excerpt' in page.content && page.content.excerpt) {
    return renderMdxPlain(page?.content.excerpt, variables, mdxOpts);
  }

  if (page?.content.body) {
    return renderMdxPlain(page.content.body, variables, mdxOpts);
  }

  return '';
}
